import requestFollow from 'request/hooks/user-follow'
let dic = {}

export default function useFollow() {
  // eslint-disable-next-line no-unused-vars
  const { data, mutate } = useSWR('hooks/follow', uuid)

  const { user, key } = useCurrent()
  const panel = usePanel()

  const toggleFollow = async userId => {
    if (!user) return panel.open('auth')
    const action = dic[userId] ? 'unfollow' : 'follow'
    await requestFollow(userId, action)
    mkt.followClick()
  }

  const isFollowing = userId => !!dic[userId]

  s.FollowUpdate = ({ userId, event }) => {
    dic[userId] = event === 'follow'
    mutate()
  }

  useEffect(() => {
    const fetchDic = () => {
      if (!user) return {}
      return user.followingIds.trueDic()
    }
    dic = fetchDic()
    mutate()
  }, [key])

  return { isFollowing, toggleFollow }
}
